import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router';
import { homePath, isMobile, newsKey, pageChangeTimeout, productsKey, } from '../globalUtils';
import usePageStore from '../Page/pageStore';
import useDataStore from '../Data/dataStore';
import useMenuStore from '../Menu/menuStore';
const getPage = (urlPath) => urlPath?.split('/').filter(Boolean).pop() ?? '';
export const getPath = (path) => getPage(path) || homePath;
export const detectBlog = (path) => {
    const pathArray = path?.split('/').filter(Boolean);
    return pathArray[0] === newsKey && pathArray.length > 1;
};
export const detectProducts = (path) => {
    const pathArray = path?.split('/').filter(Boolean);
    return pathArray[0] === productsKey && pathArray.length > 1;
};
const Router = () => {
    const currentPage = useRef('');
    const content = useDataStore((state) => state.data[currentPage.current]);
    const { shownPage, blockSnap } = usePageStore();
    const urlPath = useLocation().pathname;
    const navigationType = useNavigationType(); // 'PUSH' | 'POP' | 'REPLACE'
    const timeout = useRef(0);
    const mounted = useRef(false);
    const snapInited = useRef(false);
    const scrollPositions = useRef({});
    const scrollSections = useRef({});
    const urlPathRef = useRef(urlPath);
    useEffect(() => {
        scrollPositions.current[urlPathRef.current] = window.scrollY;
        scrollSections.current[urlPathRef.current] =
            usePageStore.getState().activeSection;
        urlPathRef.current = urlPath;
    }, [urlPath]);
    useEffect(() => {
        document.documentElement.style.scrollSnapType = 'none';
        const newPath = getPath(urlPath);
        usePageStore.getState().setActivePage(newPath);
        usePageStore.getState().setShownSection(-1);
        usePageStore.getState().setActiveSection(-1);
        usePageStore.getState().setBlockSnap(blockSnap + 1);
        useMenuStore.getState().setOpen(false);
        currentPage.current = newPath;
        clearTimeout(timeout.current);
        timeout.current = window.setTimeout(registerNewPage, !mounted.current ? 10 : pageChangeTimeout * 1000);
        mounted.current = true;
    }, [urlPath]);
    useEffect(() => {
        scrollToPlace();
    }, [shownPage]);
    useEffect(() => {
        if (!snapInited.current && content) {
            snapInited.current = true;
            if (content?.snap) {
                document.documentElement.style.scrollSnapType = 'y mandatory';
            }
        }
    }, [content]);
    const scrollToPlace = () => {
        const scrollToTop = { behavior: 'instant', top: 0 };
        let scrollSection = 0;
        if (navigationType === 'POP') {
            scrollToTop.top = scrollPositions.current[urlPath] ?? 0;
            scrollSection = scrollSections.current[urlPath] ?? 0;
        }
        // Brute force scrolling
        // NOTE: Check location.hash scroll times when you set the scroll intervals
        const page = currentPage.current;
        const forceTimes = isMobile ? [50, 200, 300] : [0, 20, 70];
        // FOr non snappy pages this one scroll seem to be enough
        requestAnimationFrame(() => window.scrollTo(scrollToTop));
        const snappy = useDataStore.getState().data?.[currentPage.current] &&
            useDataStore.getState().data?.[currentPage.current]?.snap;
        if (snappy) {
            setTimeout(() => {
                if (page === currentPage.current) {
                    window.scrollTo(scrollToTop);
                }
            }, forceTimes[0]);
            setTimeout(() => {
                if (page === currentPage.current) {
                    window.scrollTo(scrollToTop);
                }
            }, forceTimes[1]);
            setTimeout(() => {
                if (page === currentPage.current) {
                    document.documentElement.style.scrollSnapType = 'y mandatory';
                    window.scrollTo(scrollToTop);
                }
            }, forceTimes[2]);
        }
        usePageStore.getState().setActiveSection(scrollSection);
        usePageStore.getState().setShownSection(scrollSection);
    };
    const registerNewPage = () => {
        usePageStore.getState().setShownPage(currentPage.current);
    };
    return null;
};
export default Router;
